import { render, staticRenderFns } from "./bnvtomany.vue?vue&type=template&id=3e39c464&scoped=true&"
import script from "./bnvtomany.vue?vue&type=script&lang=js&"
export * from "./bnvtomany.vue?vue&type=script&lang=js&"
import style0 from "./bnvtomany.vue?vue&type=style&index=0&id=3e39c464&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e39c464",
  null
  
)

export default component.exports